import COUNTRIES from './countries.json'

const PRIORITY_COUNTRY_CODES = ['GB', 'US']

const EUROPEAN_COUNTRY_CODES = new Set([
  'AD', 'AL', 'AT', 'AX', 'BA', 'BE', 'BG', 'BY', 'CH', 'CY', 'CZ', 'DE', 'DK', 'EE',
  'ES', 'FI', 'FO', 'FR', 'GB', 'GG', 'GI', 'GR', 'HR', 'HU', 'IE', 'IM', 'IS', 'IT',
  'LI', 'LT', 'LU', 'LV', 'MC', 'MD', 'ME', 'MK', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO',
  'RS', 'RU', 'SE', 'SI', 'SJ', 'SK', 'SM', 'TR', 'UA', 'VA', 'XK'
])

const toIntlLocale = language => language === 'jp-JP' ? 'ja-JP' : language

export const getCountryDisplayName = (country, language) => {
  if (!country) return ''

  try {
    if (typeof Intl !== 'undefined' && Intl.DisplayNames) {
      const displayName = new Intl.DisplayNames([toIntlLocale(language || 'en-GB')], { type: 'region' })
      return displayName.of(country.code) || country.name
    }
  } catch (error) {
    // Older browsers and unsupported locales use the supplied English name.
  }

  return country.name
}

const compareCountries = language => (left, right) =>
  getCountryDisplayName(left, language).localeCompare(getCountryDisplayName(right, language), toIntlLocale(language || 'en-GB'))

export const getCountryGroups = language => {
  const byCode = new Map(COUNTRIES.map(country => [country.code, country]))
  const priority = PRIORITY_COUNTRY_CODES
    .map(code => byCode.get(code))
    .filter(Boolean)

  const european = COUNTRIES
    .filter(country => EUROPEAN_COUNTRY_CODES.has(country.code) && !PRIORITY_COUNTRY_CODES.includes(country.code))
    .sort(compareCountries(language))

  const priorityCodes = new Set([...priority, ...european].map(country => country.code))
  const allOtherCountries = COUNTRIES
    .filter(country => !priorityCodes.has(country.code))
    .sort(compareCountries(language))

  return {
    priority: [...priority, ...european].map(country => ({
      ...country,
      name: getCountryDisplayName(country, language)
    })),
    allOtherCountries: allOtherCountries.map(country => ({
      ...country,
      name: getCountryDisplayName(country, language)
    }))
  }
}
